import React, { useState, useEffect, useRef } from "react";
import { Col, Typography, Input, DatePicker, Modal, Button, Menu, message, Row, Space, Form, Popconfirm, Select, Radio, Checkbox, Card } from "antd";
import dayjs from 'dayjs'
import ProTableOT from "../utility/ProTable_ot";
import styled from "styled-components";
import axios from "axios";
import AppointmentForm from "./views/AppointmentForm";
import { useArticleManagement } from "./controller/ArticleManagementController";
import ArticleManagementModal from "./views/ArticleManagementModal";
import { useNavigate } from "react-router-dom";



const { Title, Paragraph, Text, Link } = Typography;

const ArticleManagement = () => {
    const navigate = useNavigate();
    const columns = [{
        title: '標題',
        key: 'title',
        dataIndex: 'title',
        align: 'center'
    },
    {
        title: '內容',
        key: 'content',
        dataIndex: 'content',
        align: 'center',
        width: '25rem'
    },
    {
        title: '文章分類',
        key: 'blog_type_id',
        dataIndex: 'blog_type_id',
        align: 'center'
    },
    {
        title: '連結',
        key: 'external_link',
        dataIndex: 'external_link',
        align: 'center',
        width: '25rem'

    },
    {
        title: '直播室連結',
        key: 'blog_room_data',
        dataIndex: 'blog_room_data',
        align: 'center',
        render: ((text, record, index) => {
            return text.map((value) => {
                return <Button
                    type="link"
                    onClick={() => {
                        navigate(`/officialweb/admin/audio_recorder/liveAdmin/${value?.room_id}`)
                    }}
                >
                    前往
                </Button>
            })

        })
    },
   
    {
        title: '最後編輯時間',
        key: 'last_edit_time',
        dataIndex: 'last_edit_time',
        align: 'center'
    },

    {
        title: '操作',
        valueType: 'option',
        key: 'option',
        fixed: 'right',
        sorter: false,
        disabled: true,
        render: (text, record, _index) => {
            return (
                <Space wrap>
                    <Button
                        type="link"
                        style={{
                            color: '#2BC17B'
                        }}
                        onClick={() => {
                            handleEditRow(record)
                        }}
                    >
                        修改
                    </Button>
                    <Popconfirm
                        title="刪除項目"
                        description="確定刪除勾選項目?"
                        onConfirm={() => handleDeleteRow(record?.blog_id)}
                        onCancel={() => { }}
                    >
                        <Button
                            type="link"
                            danger>
                            刪除
                        </Button>
                    </Popconfirm>
                </Space>
            )
        }
    }];
    const [extra_columns, set_extra_columns] = useState([]);
    const actionRef = useRef();
    const [pageSize, setPageSize] = useState(20)
    const [selectedRowKeys, setSelectedRowKeys] = useState([])
    const [selectedRowsInfo, setSelectedRowsInfo] = useState([])
    const rowSelection = {
        //不一定都是對id
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = [...selectedRowKeys]
            let selectRow = [...selectedRowsInfo]
            if (selected) {
                changeRows.map((value, key) => {
                    select_temp.push(value.blog_id)
                    selectRow.push(value)
                })

            }
            else {
                changeRows.map((value, key) => {
                    const index = select_temp.indexOf(value.blog_id);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);

                })
            }
            setSelectedRowKeys(select_temp)
            setSelectedRowsInfo(selectRow)
        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = [...selectedRowKeys]
            let selectRow = [...selectedRowsInfo]
            if (selected) {
                select_temp.push(record.blog_id)
                selectRow.push(record)
            }
            else {
                select_temp = select_temp.filter(key => key !== record.blog_id)
                selectRow = selectRow.filter(row => row.blog_id !== record.blog_id)
            }
            setSelectedRowKeys(pre => select_temp)
            setSelectedRowsInfo(selectRow)

        },
        getCheckboxProps: (record) => ({
            // disabled: record.pass === null,
        }),
    };
    const [modalOpen, setModalOpen] = useState(false)
    const [modalLoading, setModalLoading] = useState(false)

    const [form] = Form.useForm();

    const [axiosMode, setAxiosMode] = useState("get")
    const onCleanSelected = () => {
        setSelectedRowKeys([])
        setSelectedRowsInfo([])
    }
    const handleAddRow = () => {
        setAxiosMode("post")
        setModalOpen(true)
        form.resetFields()
    }
    const handleEditRow = (record) => {
        setAxiosMode("patch")
        setModalOpen(true)
        // let news_time = dayjs(record?.news_time, "YYYY-MM-DD HH:mm:ss")
        // let announce_time_end = record?.announce_time_end ? dayjs(record?.announce_time_end, "YYYY-MM-DD HH:mm:ss") : record?.announce_time_end


        form.resetFields();
        form.setFieldsValue({
            ...record,
            // news_time,
            // announce_time_end
        })
    }
    const handleDeleteRow = (id) => {
        let data = []
        if (id) {
            data = [{
                blog_id: id
            }]
        }

        else {
            data = selectedRowsInfo.map((val) => {
                return {
                    blog_id: val?.blog_id
                }
            })
        }
        if (data.length > 0) {
            deleteArticleManagement(data)
        }
        else {
            message.info("請選擇項目")
        }
    }

    const onFormFinish = (values) => {
        console.log(values)
        if (axiosMode === "post") {
            postArticleManagement([values])
        }
        else if (axiosMode === "patch") {
            patchArticleManagement([values])
        }
    }
    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success("新增成功")
                actionRef.current.reloadAndRest();

            }
            else if (axiosMode === "patch") {
                message.success("修改成功")
                actionRef.current.reloadAndRest();

            }
            else if (axiosMode === "delete") {
                message.success("刪除成功")
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([])
                setSelectedRowsInfo([])

            }
            setModalLoading(false)
            setModalOpen(false)
        }
        else if (status === "error") {
            if (axiosMode === "post") {
                message.error("新增失敗")
                actionRef.current.reloadAndRest();
            }
            else if (axiosMode === "patch") {
                message.error("修改失敗")
                actionRef.current.reloadAndRest();
            }
            else if (axiosMode === "delete") {
                message.error("刪除失敗")
                actionRef.current.reloadAndRest();
            }
            setModalLoading(false)
            setModalOpen(false)
        }
    }
    const onBefore = ({ axiosMode, status, values }) => {
        setModalLoading(true)
    }
    const setParamsFilter = (obj) => {
        //拿掉值為空或是null 的東西
        return Object.entries(obj).reduce((all, [key, value]) => value === "" ? { ...all } : { ...all, [key]: value }, {})
    }

    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
    } = useTableColumnsCheck(columns)

    const {
        getArticleManagement,
        postArticleManagement,
        patchArticleManagement,
        deleteArticleManagement,
        // patchAppointmentclick
    } = useArticleManagement({
        onFinish,
        onBefore,
    })

    useEffect(() => {
        checkAll()
    }, [])

    return (
        <Row gutter={[10, 20]} justify="space-around" style={{ padding: "20px", backgroundColor: '#f5f5f5' }}>
            <Col
                span={24}
            >
                <Card
                    title="文章管理"
                >
                    <Col>
                        <ArticleManagementModal
                            axiosMode={axiosMode}
                            propsOpen={modalOpen}
                            propsSetOpen={setModalOpen}

                            propsForm={form}

                            propsLoading={modalLoading}
                            propsSetLoading={setModalLoading}

                            onFinish={onFormFinish}
                        />
                    </Col>

                    <ProTableOT
                        actionRef={actionRef}
                        headerTitle={<Space>
                            {/* <Button
                        type='primary'
                        onClick={() => {
                            handleAddRow()
                        }}
                        style={{
                            backgroundColor: "#FFF9C9",
                            color: "#000"
                        }}
                    >
                        + 發佈諮詢名單
                    </Button> */}


                        </Space>}
                        columns={columns}
                        check={check}
                        setCheck={setCheck}
                        rowKey={'blog_id'}
                        selections={{
                            // onChange: (index_, data_) => set_data(data_)
                        }}
                        toolBarRender={() => [
                            <Popconfirm
                                title="刪除文章"
                                description="確定刪除勾選的文章?"
                                onConfirm={() => handleDeleteRow()}
                                onCancel={() => { }}
                            >
                                <Button
                                    type='primary'
                                    style={{
                                        color: "#000",
                                        backgroundColor: "#ffedee"
                                    }}

                                >
                                    刪除文章
                                </Button>
                            </Popconfirm>
                        ]}
                        extra_columns={extra_columns}
                        set_extra_columns={set_extra_columns}
                        manage_columns={false}
                        request={async (params = {}, sort, filter) => {
                            setAxiosMode("get")
                            let newParams = {
                            };
                            let order = setOrders(sort)
                            newParams = {
                                ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                                ...newParams,
                                order,
                                size: params?.pageSize,
                                cur_page: params.current,
                                custom_filter_value: params.keyword ?? "",
                                custom_filter_key: custom_filter_key
                            };
                            newParams = setParamsFilter({
                                ...newParams,
                            });
                            setPageSize(params?.pageSize ?? 20)

                            return getArticleManagement(newParams)
                            // return []
                        }}
                        pageSize={pageSize}
                        rowSelection={{
                            type: 'checkbox',
                            selectedRowKeys: selectedRowKeys,
                            ...rowSelection,
                        }}
                        tableAlertOptionRender={() => {
                            return (
                                <Space size={16}>
                                    {/* <Typography.Link>匯出資料</Typography.Link> */}
                                </Space>
                            )
                        }}
                        tableAlertRender={({
                            selectedRowKeys,
                            selectedRows,
                            // onCleanSelected,
                        }) => {
                            return (
                                <Space size={24}>
                                    <span>
                                        已選擇 {selectedRowKeys.length} 項
                                        <a style={{ marginInlineStart: 8 }} onClick={onCleanSelected}>
                                            取消選擇
                                        </a>
                                    </span>
                                </Space>
                            );
                        }}
                        scroll={{
                            x: "max-content"
                        }}

                    />
                </Card>
            </Col>
        </Row>
    )
}

const useTableColumnsCheck = (columns) => {
    const [check, setCheck] = useState([])
    const checkAll = () => {
        setCheck((pre) => {
            return columns
                .filter((element) => !element.disabled)
                .map((val) => val.key);
        });
    }
    const setOrders = (sorter) => {
        let newOrders = Object.keys(sorter).map((key, index) => {
            if (sorter[key] === "descend") {
                return JSON.stringify({
                    column: key,
                    type: 'DESC'
                })
            }
            else {
                return JSON.stringify({
                    column: key,
                    type: 'ASC'
                })
            }

        })
        return newOrders
    }
    return {
        check,
        custom_filter_key: check,
        setCheck,
        checkAll,
        setOrders
    }
};
export default ArticleManagement;